<template>
  <p class="footicp" :class="['icp_' + $route.name]" v-if="LIMI_ENV">
    <!-- Copyright © {{year}} 名师火箭班
    <a href="/static/agreement/agreement.html" target="_blank">用户协议</a>
    <a target="_blank" href=" https://beian.miit.gov.cn/#/Integrated/index">
      京ICP备15050766号
    </a>
    <img src="../../assets/img/common/beian.png" />
    <a
      target="_blank"
      href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502033665"
    >
      京公网安备 11010502033665号
    </a> -->
  </p>
</template>
<script>
import common from 'common';
export default {
  data() {
    return {
	  LIMI_ENV: LIMI_ENV !== "electron",
	  year:new Date(common.getTemServerTime()*1000).getFullYear(),
	};
  }
};
</script>

<style rel="stylesheet/stylus" lang="less" scoped>
.footicp {
  width: 100%;
  text-align: center;
  position: fixed;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0.3;
  font-size: 14px;
  line-height: 14px;
  color: #fff;
  a {
    color: #fff;
  }
  img {
    border: none;
    vertical-align: middle;
    opacity: 0.88;
  }
}
.icp_course {
  position: absolute;
  bottom: -30px;
}
@media screen and (max-height: 668px) {
  .footicp {
    bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basic/icp.vue